/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S6_HeadingInputs */

const tr_cerez_s6_heading = /** @type {(inputs: Cerez_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Çerez Bilgilendirmesi ve Tarayıcı Ayarları`)
};

const en_cerez_s6_heading = /** @type {(inputs: Cerez_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Cookie Notice and Browser Settings`)
};

const de_cerez_s6_heading = /** @type {(inputs: Cerez_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Cookie-Hinweis und Browsereinstellungen`)
};

const ru_cerez_s6_heading = /** @type {(inputs: Cerez_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Уведомление о cookie и настройки браузера`)
};

/**
* | output |
* | --- |
* | "6. Cookie Notice and Browser Settings" |
*
* @param {Cerez_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s6_heading = /** @type {((inputs?: Cerez_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s6_heading(inputs)
	if (locale === "de") return de_cerez_s6_heading(inputs)
	if (locale === "ru") return ru_cerez_s6_heading(inputs)
	return tr_cerez_s6_heading(inputs)
});